import React, {useRef, useMemo} from 'react';

import { Button } from '../../components/Button';
import { Section } from '../../components/Section';
import { ReviewsSlider} from "../../components/ReviewsSlider";

import banner1 from "./images/banner-1.jpg"
import banner2 from "./images/banner-2.jpg"
import banner3 from "./images/banner-3.jpg"
import banner4 from "./images/banner-4.jpg"
import banner5 from "./images/banner-5.jpg"
import banner6 from "./images/banner-6.jpg"
import apple from "./images/apple.png"
import mappamondo from "./images/mappamondo.png"
import portaleImage from "./images/portale.jpg"
import comingImage from "./images/coming.jpeg"
import scopriImage from "./images/scopri.jpg"
import logoPed from "./images/logo-ped.png"
import logoPueri from "./images/logo-pueri.png"
import logoSdb from "./images/logo-sdb.png"

import Slider from "react-slick";

import './styles/index.scss';
import {TextImage} from "../../components/TextImage";
import {SliderHero} from "../../components/SliderHero";

export const Landing = () => {
  const sliderRef = useRef();
  const sliderImages = useMemo(
    () => {
      return [
          //{ original: banner0, originalAlt: "Buona Estate! - Nutri il Sapere" },
          { original: banner6, originalAlt: "Focus su frutta e verdura" },
          { original: banner1, originalAlt: "Benvenuti nella sezione di Nutri il Sapere" },
          //{ original: banner2, originalAlt: "Il progetto didattico per le scuole" },
          { original: banner3, originalAlt: "e per chi ha sempre tanta voglia di imparare" },
          { original: banner4, originalAlt: "alla scoperta del meraviglioso mondo del cibo" },
          { original: banner5, originalAlt: "e delle buone abitudini per crescere e vivere alla grande" },
        ]

    }
  );

  const reviews = useMemo(
    () => {
      return [
        {
          name: "Giuseppina",
          school: "J. Ferrazzi",
          text: "Interessante e formativo."
        },
        {
          name: "Anna",
          school: "E. DeAmicis",
          text: "Il progetto ha suscitato grande entusiasmo negli alunni che hanno partecipato attivamente e con interesse a tutte le attività formative proposte. Grazie!"
        },
        {
          name: "Rosy",
          school: "I.C. Sant'Ambrogio",
          text: "Ottimo progetto."
        },
        {
          name: "Elisabetta",
          school: "I.C. Modugno",
          text: "Il progetto Nutri il Sapere unisce le conoscenze al gioco e rende i contenuti non solo molto fruibili ma anche interessanti."
        },
        {
          name: "Giuseppina",
          school: "I.C. Fossato",
          text: "Progetto molto apprezzato perché ben fornito di informazioni utili."
        }, {
          name: "Rosy",
          school: "I.C. Santambrogio",
          text: "Salve! In tutti e 3 i plessi della Primaria gli alunni hanno gradito molto la vostra iniziativa. Speriamo di partecipare in nuovi progetti. Grazie mille!"
        }
      ]
    }
  );
  return (
    <div className="Landing">
      <Section>
        <div className="container">
          <SliderHero images={sliderImages}>
          </SliderHero>
        </div>
      </Section>
      <Section>
        <div className="container">
          <p className="text-center">Conosci la piramide alimentare? Sai cos’è un falso frutto? E la piramide… del
            movimento?<br />Niente paura! C’è <strong>Nutri il Sapere</strong>, il <strong>progetto educativo di Pam</strong> destinato alle scuole primarie e a tutti coloro che, grandi e piccini, non smetterebbero
              mai di imparare!</p>
        </div>
      </Section>
      <Section>
        <div className="text-center button">
          <Button label="Area Docenti" href="https://pamretailpro.it/landing/nutri-sapere-docenti/" target="_top" uppercase={true} backgroundColor="#00924d" size="regular"></Button>
          <Button label="Area Famiglie" href="https://pamretailpro.it/nutri-il-sapere-area-famiglie/" target="_top" uppercase={true} backgroundColor="#00924d" size="regular"></Button>
        </div>
      </Section>
      {/* <Section>
        <p className="text-center info-title">Aderiscono al progetto:</p>

        <div className="info">
          <img src={apple} />
          <span>
                        <h4>466</h4>
                        <p>classi</p>
                    </span>
          <span>
                        <h4>276</h4>
                        <p>docenti</p>
                    </span>
          <img src={mappamondo} />
        </div>
        <div className="info">
					<span>
                        <h4><span className="small">oltre</span> 10.000</h4>
                        <p className="near">studenti</p>
                    </span>
        </div>
      </Section>
      <Section>
        <ReviewsSlider reviews={reviews} backgroundColor="#3b65aa" color="#ffffff" slideColor="#053b99"></ReviewsSlider>
      </Section> */}
      <Section>
        {/* <TextImage
          text={<>
            Il nostro obiettivo? Offrire a docenti e famiglie un valido
            supporto formativo per la promozione della <strong>consapevolezza
            alimentare</strong> e dell’adozione di <strong>stili di vita salutari</strong>,
            fin dalla tenera età.<br/><br/>
          </>}
          image={portaleImage}
          reverse
        /> */}

        <TextImage
          text={<>
            <strong>Gioca con tuo figlio completando insieme le speciali missioni</strong> dedicate alle tematiche
            Nutri il Sapere: potrete mettere alla prova le vostre conoscenze, imparando quanto è importante seguire un’alimentazione equilibrata
            e avere uno stile di vita attivo.
          </>}
          image={comingImage}
        />

        <TextImage
          text={<>
            <strong>Mangiare bene, conoscere l’origine e le proprietà degli alimenti
              e comprendere l’importanza di uno stile di vita equilibrato</strong> sono
            elementi essenziali per la crescita dei più piccoli:&nbsp;scopri come con Nutri il Sapere!<br/><br/>
            Il progetto è stato realizzato in collaborazione
            con il <strong><a href="https://www.sdb.unipd.it/">Dipartimento di Salute Donna e Bambino
            dell’Università di Padova</a></strong>&nbsp;
            e con <strong><a href="https://www.fondazionesaluspueri.it/">Fondazione Salus Pueri</a></strong>, che
            dal 1992 sostiene la Pediatria di Padova nella sua globalità
            per creare un vero e proprio ospedale a misura di bambino e della sua famiglia.

          </>}
          image={scopriImage}
          reverse
        />
      </Section>
      <Section>
        <div className="container" style={{ textAlign: "center", marginTop: "6rem" }}>
          <p>in collaborazione con</p>
          <a href="https://www.fondazionesaluspueri.it/">
            <img src={logoPueri} style={{ marginRight: "1rem" }} alt="Fondazione Salus Pueri" />
          </a>
          <a href="https://www.sdb.unipd.it/">
            <img src={logoSdb} style={{ marginRight: "1rem" }} alt="Dipartimento Salute Donna e Bambino" />
          </a>
          <img src={logoPed} alt="Pediatria di Padova" />
        </div>
      </Section>
    </div>
  )
}
